import { Link } from 'react-router-dom';

interface PageBannerProps {
  eyebrow: string;
  title: string;
  description: string;
  breadcrumb: { label: string; to?: string }[];
}

export default function PageBanner({ eyebrow, title, description, breadcrumb }: PageBannerProps) {
  return (
    <section className="w-full bg-primary-950 pt-28 pb-14 md:pt-36 md:pb-20 px-4 md:px-8">
      <div className="w-full max-w-4xl">
        <nav aria-label="面包屑导航" className="mb-6">
          <ol className="flex flex-wrap items-center gap-2 text-xs md:text-sm text-background-300">
            {breadcrumb.map((b, i) => (
              <li key={b.label} className="flex items-center gap-2">
                {b.to ? (
                  <Link to={b.to} className="hover:text-background-50 transition-colors cursor-pointer">
                    {b.label}
                  </Link>
                ) : (
                  <span className="text-background-100">{b.label}</span>
                )}
                {i < breadcrumb.length - 1 && <i className="ri-arrow-right-s-line text-base"></i>}
              </li>
            ))}
          </ol>
        </nav>
        <span className="font-heading text-sm tracking-widest text-accent-400">{eyebrow}</span>
        <h1 className="mt-3 font-heading text-4xl md:text-6xl leading-tight text-background-50">{title}</h1>
        <p className="mt-5 text-sm md:text-base leading-8 text-background-200 max-w-2xl">{description}</p>
      </div>
    </section>
  );
}